import { useNavigate } from "react-router-dom";
import styles from './BtnSairConta.module.css'

function BntSairConta(){
    
    const navigate = useNavigate();

    const sairConta = () => {
    localStorage.clear();
    navigate("/home");
  };

  return(
      <div className={styles.caixaBtn}>
          <button className={styles.logoutBtn} onClick={sairConta}>
                  Sair da conta
               </button>
      </div>
  )


}

export default BntSairConta